import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import { useBranding } from '../../contexts/BrandingContext';

const Footer = () => {
    const { branding } = useBranding();
    return (
        <Box component="footer" sx={{ bgcolor: 'background.default', ml: { sm: '264px' }, px: 2, py: 2.5 }}>
                
            <Typography variant="body2" color="text.secondary" align="center">
                {'Copyright © '}
                <Link color="inherit" href="https://telemedconnect.ru/" underline="hover">{branding.organizationName}</Link>
                {' '}{new Date().getFullYear()}{'.'}
            </Typography>
    </Box>
);
};

export default Footer;
